import { ReactNode } from "react";

import { formatChartRelatedValue } from "./formatChartRelatedValue";
import { ConfigRelatedDataSource } from "../types";
import { LayerInfo } from "../../../interfaces/resourceInfo";

export const tooltipValueFromRelatedFeatures = (
  value: number,
  relatedAttributes: ConfigRelatedDataSource[],
  layerInfo: LayerInfo,
): number | string | ReactNode => {
  return formatChartRelatedValue(value, layerInfo, relatedAttributes);
};
